import { $api } from '@service/RequestService';
import { stringifyUrl } from 'query-string';
import { useQuery } from 'react-query';

import { dashboardV2Constants, dashboardV2Models } from '..';

export const useDashboardWidgetStaticCallHistoryId = ({
  id,
  ...props
}: {
  id: number;
  startDate?: string | null;
  finishDate?: string | null;
  responsibleByIds?: (number | null)[] | null;
}) => {
  const data = useQuery<dashboardV2Models.IDashboardWidgetStaticCallHistoryId>({
    queryKey: [dashboardV2Constants.queryKeys.DASHBOARD_WIDGET_STATIC_CALL_HISTORY_ID, id, props],
    queryFn: async () => {
      const res = await $api.get(
        stringifyUrl({
          url: `/v1/dashboard/widget/static/call-history/${id}`,
          query: props
        })
      );

      return res?.data?.data;
    }
  });

  const convert = (data?.data?.result || [])?.reduce<{
    max: number;
  }>(
    (p, c) => {
      if (c?.inboundCount + c?.outboundCount > p?.max) {
        p.max = c?.inboundCount + c?.outboundCount;
      }

      return p;
    },
    { max: 0 } as {
      max: number;
    }
  );

  return { ...data, ...convert };
};
